import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { FAQ } from "@/data/content";
import BrandMarkWatermark from "@/components/BrandMarkWatermark";

export default function Faq() {
  const { t, lang } = useLang();
  const [open, setOpen] = useState(FAQ[0].id);

  return (
    <section id="faq" className="relative overflow-hidden section-y bg-[color:var(--bone)]" data-testid="faq-section">
      <BrandMarkWatermark size={620} opacity={0.09} style={{ top: 40, left: -80, zIndex: 1 }} />
      <div className="container-lux">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="overline" data-testid="faq-overline">{t.faq.overline}</div>
            <h2
              className="mt-6 font-serif-display text-[clamp(2rem,3.6vw,3rem)] leading-[1.05] tracking-[-0.01em] text-[color:var(--anthracite)] sticky top-24"
              data-testid="faq-title"
            >
              {t.faq.title}
            </h2>
          </div>

          <div className="lg:col-span-8">
            {FAQ.map((item) => {
              const isOpen = open === item.id;
              return (
                <div
                  key={item.id}
                  className={`acc-item ${isOpen ? "open" : ""}`}
                  data-testid={`faq-item-${item.id}`}
                >
                  <button
                    className="acc-trigger"
                    onClick={() => setOpen(isOpen ? null : item.id)}
                    aria-expanded={isOpen}
                    data-testid={`faq-trigger-${item.id}`}
                  >
                    <span className="font-serif-display text-[20px] md:text-[24px] leading-tight text-[color:var(--anthracite)]">
                      {item.q[lang] || item.q.en}
                    </span>
                    <span className="acc-icon" aria-hidden />
                  </button>
                  <div className="acc-content">
                    <div className="acc-content-inner">{item.a[lang] || item.a.en}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
